import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Footer from '../components/Footer';
import { useHistory, useLocation } from "react-router-dom";
import Modal from 'react-modal';
import { AiOutlineClose } from 'react-icons/ai'; // Close icon
import Marquee from 'react-fast-marquee';
import { RWebShare } from "react-web-share";




// {
//   "language":"",
//   "poster: "",
//   "overview":"",
//   "releasedate":"",
//   "latest":"",
//   "server1":"",
//   "server2":"",
//   "download":"",
//   "downloadable":"",
//   "hindidownload":""
  
// }


const baseUrl ="https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&api_key=6ca13f43a1a801b9dda8e5bf874d1e3e&page=1";
const searchApi = "https://api.themoviedb.org/3/search/movie?&api_key=6ca13f43a1a801b9dda8e5bf874d1e3e&query=";

function MovieScreen(props) {

  window.scrollTo(0, 0);

  // Direct link code start

  const links = [
    'https://www.profitableratecpm.com/decf6q7di?key=a4f21406e35277c2c60a8e74d5b665e7',
    'https://www.cpmrevenuegate.com/siinmp29?key=d4ec47048b3bf214fadb7091e2d524d1',
    'https://www.profitableratecpm.com/decf6q7di?key=a4f21406e35277c2c60a8e74d5b665e7',
    'https://www.effectiveratecpm.com/ebrte7dc?key=5acd73bdcd9a40d2d2a6e6376b7c902e',
    'https://www.profitableratecpm.com/decf6q7di?key=a4f21406e35277c2c60a8e74d5b665e7',
  ];
  
  useEffect(() => {
    // Function to handle clicks and open random links
    const handleClick = () => {
      const lastClickTime = localStorage.getItem('lastClickTime');
      const now = new Date().getTime();

      // If there's no last click time or if 10 minutes have passed, open a new link
      if (!lastClickTime || now - lastClickTime >= 10000) {
        // Get a random link from the array
        const randomLink = links[Math.floor(Math.random() * links.length)];

        // Open the link in a new tab
        window.open(randomLink, '_blank');

        // Update the last click time in localStorage
        localStorage.setItem('lastClickTime', now);
      }
    };

    // Add click event listener
    window.addEventListener('click', handleClick);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);
    

  // Direct link code end

    
    const [movies , setMovies] = useState([]);
    const [searchTerm , setSearchTerm] = useState('');

    let history = useHistory();

    const location = useLocation();

    const { movieProps } = location.state || { movieProps: {} };

    const [backEnd , setBackEnd] = useState({});


    const movieId = props?.match?.params?.id;

    const iframeSrc = `https://www.2embed.cc/embed/${movieId}`;
    // const [iframeSrc, setIframeSrc] = useState(`https://www.2embed.cc/embed/${movieId}`);

   


    useEffect(
        () => {
    fetch(baseUrl)
    .then(res => res.json())
    .then((data) => {
      setMovies(data.results);
    
    });
        },[]
      ); 

   

    const handleSubmit = (e) => {

        e.preventDefault();
      
      if(searchTerm){
      
        fetch(searchApi + searchTerm)
      .then(res => res.json())
      .then((data) => {
        setMovies(data.results);

        console.log(data.results);
      }
      )
      
      .catch(err => console.log('error', err));;
      
      setSearchTerm('');
      };

      if(searchTerm.trim()){
        history.push(`/search/${searchTerm}`);
      }
      
      
        
      
      }

    const handleOnChange = (e) => {

        setSearchTerm(e.target.value);
      }






      //Backend Api

          //       useEffect(
          //   () => {
          //     fetch(`/api/movies/${movieId}`)
          //     .then(res => res.json())
          //     .then((data) =>{

          //       setBackEnd(data);

          //       console.log(data);
                
          //     })
          //   }, [movieId]
          // );

          useEffect(() => {

            fetch(`https://serverless-movie-backend.vercel.app/api/movies/${movieId}`)
              .then((res) => {
                console.log('Response:', res);
                if (!res.ok) {
                  throw new Error('Network response was not ok ' + res.statusText);
                }
                return res.json(); // Assuming the API returns JSON
              })
              .then((data) => {
               // console.log('Data:', data);
                setBackEnd(data);
              })
              .catch((error) => {
                console.error('Fetch error:', error);
              });
          }, [movieId]);
  

      //Backend Api
      // iframe
      


      
      // const bannerRef = useRef(null); // Initialize ref

      // const atOptions = {
      //   key: 'f7f99d04d4ff24043129015379ac1363', // Your actual key
      //   format: 'iframe',
      //   height: 90,
      //   width: 728,
      //   params: {},
      // };
    
      // useEffect(() => {
      //   // Only add the script if the bannerRef is defined and has no children
      //   if (bannerRef.current && !bannerRef.current.firstChild) {
      //     const conf = document.createElement('script');
      //     const script = document.createElement('script');
    
      //     // Set ad options
      //     conf.innerHTML = `atOptions = ${JSON.stringify(atOptions)}`;
      //     script.type = 'text/javascript';
      //     script.src = `//www.topcreativeformat.com/${atOptions.key}/invoke.js`;
    
      //     // Append scripts to the banner div
      //     bannerRef.current.appendChild(conf);
      //     bannerRef.current.appendChild(script);
      //   }
      // }, []); // Run only once on mount   
      
      



      // const bannerRef2 = useRef(null); // Initialize ref

      // const atOptions2 = {
      //   key: '648a5273de281afba700b004292c0e61', // Your actual key
      //   format: 'iframe',
      //   height: 50,
      //   width: 320,
      //   params: {},
      // };
    
      // useEffect(() => {
      //   // Only add the script if the bannerRef is defined and has no children
      //   if (bannerRef2.current && !bannerRef2.current.firstChild) {
      //     const conf2 = document.createElement('script');
      //     const script2 = document.createElement('script');
    
      //     // Set ad options
      //     conf2.innerHTML = `atOptions = ${JSON.stringify(atOptions2)}`;
      //     script2.type = 'text/javascript';
      //     script2.src = `//www.topcreativeformat.com/${atOptions2.key}/invoke.js`;
    
      //     // Append scripts to the banner div
      //     bannerRef.current.appendChild(conf2);
      //     bannerRef.current.appendChild(script2);
      //   }
      // }, []); // Run only once on mount  

      
  //     const bannerRef = useRef(null); // Reference for the banner ad container
  // const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // State to track screen size

  // const checkScreenSize = () => {
  //   setIsMobile(window.innerWidth < 768);
  // };

  // useEffect(() => {
  //   // Add event listener for screen resize
  //   window.addEventListener('resize', checkScreenSize);

  //   // Load the appropriate banner ad based on screen size
  //   loadBannerAd();

  //   // Set interval to switch ads every 1 seconds
  //   const interval = setInterval(loadBannerAd, 120000); // Change ad every 10 seconds

  //   // Clean up the event listener and interval
  //   return () => {
  //     window.removeEventListener('resize', checkScreenSize);
  //     clearInterval(interval);
  //   };
  // }, []);

  // const loadBannerAd = () => {
  //   if (bannerRef.current) {
  //     // Clear the previous ad if it exists
  //     bannerRef.current.innerHTML = '';

  //     // Load the appropriate ad based on screen size
  //     const script = document.createElement('script');
  //     const atOptions = isMobile
  //       ? {
  //           key: '648a5273de281afba700b004292c0e61',
  //           format: 'iframe',
  //           height: 50,
  //           width: 320,
  //           params: {},
  //         }
  //       : {
  //           key: 'f7f99d04d4ff24043129015379ac1363',
  //           format: 'iframe',
  //           height: 90,
  //           width: 728,
  //           params: {},
  //         };

  //     // Set the ad options in the script
  //     script.type = 'text/javascript';
  //     script.innerHTML = `atOptions = ${JSON.stringify(atOptions)};`;
      
  //     // Set the script source based on screen size
  //     const src = isMobile
  //       ? '//www.topcreativeformat.com/648a5273de281afba700b004292c0e61/invoke.js'
  //       : '//www.topcreativeformat.com/f7f99d04d4ff24043129015379ac1363/invoke.js';

  //     const adScript = document.createElement('script');
  //     adScript.src = src;

  //     // Append the script to the banner container
  //     bannerRef.current.appendChild(script);
  //     bannerRef.current.appendChild(adScript);
  //   }
  // };




  // const adContainerRef = useRef(null); // Reference for the ad container

  // useEffect(() => {
  //   // Create a script element for the Adsterra banner
  //   const script = document.createElement('script');
  //   script.async = true;
  //   script.setAttribute('data-cfasync', 'false');
  //   script.src = '//pl24583017.cpmrevenuegate.com/e53d6b1dfa2204cc62aba0669ef16a4f/invoke.js';

  //   // Append the script to the document body
  //   document.body.appendChild(script);

  //   // Cleanup function to remove the script when the component unmounts
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);
    

  const adContainerRef = useRef(null); // Reference for the ad container

  useEffect(() => {
    // Function to load the ad script
    const loadAdScript = () => {
      // Create a script element for the Adsterra banner
      const script = document.createElement('script');
      script.async = true;
      script.setAttribute('data-cfasync', 'false');
      script.src = '//pl24583017.cpmrevenuegate.com/e53d6b1dfa2204cc62aba0669ef16a4f/invoke.js';

      // Append the script to the document body
      document.body.appendChild(script);
    };

    // Load the ad for the first time
    loadAdScript();

    // Set a timeout to reload the ad once after 30 seconds (adjust as needed)
    const timeoutId = setTimeout(() => {
      // Remove existing script to avoid duplicates
      const existingScript = document.querySelector(`script[src="//pl24583017.cpmrevenuegate.com/e53d6b1dfa2204cc62aba0669ef16a4f/invoke.js"]`);
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
      // Load the ad script again
      loadAdScript();
    }, 30000); // Reload once after 30 seconds

    // Cleanup function to clear the timeout and remove the script when the component unmounts
    return () => {
      clearTimeout(timeoutId);
      const existingScript = document.querySelector(`script[src="//pl24583017.cpmrevenuegate.com/e53d6b1dfa2204cc62aba0669ef16a4f/invoke.js"]`);
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);



  useEffect(() => {
    // Check if the page has already reloaded
    const movieReloaded = localStorage.getItem('movieReloaded');
    
    if (!movieReloaded) {
      // Set the flag to prevent future reloads
      localStorage.setItem('movieReloaded', 'true');
      // Reload the page
      window.location.reload();
    } else {
      // Clear the flag to allow reloading on future visits
      localStorage.removeItem('movieReloaded');
    }
  }, []);

      
      // iframe


  // // A ADS banner
  //   const adHTML = `
  //   <div id="frame" style="width:300px; height:auto;">
  //     <iframe data-aa='2357019' src='//ad.a-ads.com/2357019?size=300x250' style='width:300px; height:250px; border:0px; padding:0; overflow:hidden; background-color: transparent;'></iframe>
  //     <a style="display: block; text-align: right; font-size: 12px;" id="preview-link" href="https://aads.com/campaigns/new/?source_id=2357019&source_type=ad_unit&partner=2357019">Advertise here</a>
  //   </div>
  //   `;

  const [fontSize, setFontSize] = useState("64px");

useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth < 640) {
      setFontSize("32px");
    } else {
      setFontSize("64px");
    }
  };

  window.addEventListener("resize", handleResize);

  // Set initial font size based on screen width
  handleResize();

  return () => {
    window.removeEventListener("resize", handleResize);
  };
}, []);

  return (
    <div
    
    //style={{backgroundColor: '#100f1f'}}

    style={{backgroundColor: '#f75123'}}
    
    
    >


<header>

<Link to="/">
<img src={require('../assets/movieloverbdlogo.png')} alt="movieloversbd logo" width="178" height="50" /> 
</Link>

  <form onSubmit={handleSubmit} >

  <input type="text" 
          className="search" 
          placeholder="Search..." 
          value={searchTerm}
          onChange={handleOnChange}
  />

  </form>
       
      </header>

    
      <Marquee style={{fontSize: fontSize, color:"#ffffff", fontWeight:"900", textTransform: "uppercase", border:"2.5px solid black", borderLeft:"none", borderRight:"none", marginBottom:"2px", marginTop:"4px"}} pauseOnHover={true} speed={60}>
      🎬 Now Streaming! Watch the Latest Movies Live, Anytime, Anywhere! Share the Fun – Invite Friends and Enjoy Movies Together! 🎥✨
      </Marquee>
<div class="container" >
  <div class="row ">
    
    <div class="col-sm col-md-8 m-2">

    {/* <iframe src="https://www.2embed.cc/embed/960876" sandbox="allow-scripts allow-same-origin" width="100%" height="500px" frameorder="0" scrolling="no" allowfullscreen="true" ></iframe> */}

     {/* <iframe title='12' src="https://www.2embed.cc/embed/" sandbox="allow-scripts allow-same-origin" width="100%" height="500px" frameborder="0" scrolling="no" allowfullscreen="true"></iframe>  */}
    
     {/* <iframe title='12' src={iframeSrc} sandbox="allow-scripts allow-same-origin" width="100%" height="500px" frameborder="0" scrolling="no" allowfullscreen="true"></iframe> */}

    
  {/* jjj */}
  {/* <div className="my-1 justify-center items-center text-white text-center banner728" ref={banner728x90Ref} style={{ width: '728px', height: '90px' }} /> */}

  {/* <div ref={banner320x50Ref} style={{margin:"auto"}} className='banner320'/> */}
   {/* 728x90 banner for desktop, hidden on mobile */}
      {/* <div
        ref={bannerRef}
        style={{ width: isMobile ? '320px' : '728px', height: isMobile ? '50px' : '90px' , margin: 'auto', marginBottom:"5px" }}
      /> */}
      
      
      <div className="my-1"
      
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',}}>

        

        {/* <div
          dangerouslySetInnerHTML={{ __html: adHTML }}
        /> */}
      <a href="https://sports-appz.netlify.app/" target="_blank">
        <img 
          src='https://res.cloudinary.com/dbj1en2jw/image/upload/v1729106206/online_live_match_football_cricket_hnzw1v.gif' alt='live cricket & football'

        />

      </a>  
      
      
      </div>

      


      

  
      <iframe title={movieProps?.title} src={iframeSrc}  allow="autoplay" width="100%" height="500px" frameorder="0" scrolling="no" allowFullScreen={true} ></iframe>
     <p>If Current Video server doesn't work Please Download.</p>
    
    <div>

      <RWebShare
        data={{
          text: "Please share with your friends and family",
          url: "https://movieloversbd.netlify.app/",
          title: "MovieLoversBD",
        }}
        onClick={() => console.log("shared successfully!")}
      >
        <button style={{width: "100%"}}>Share Our Website 🔗</button>
      </RWebShare>

    </div>
    
     
     


     
    
    </div>
    
    <div class="col-md-3 d-none d-md-block pt-4">
                        <div class="rightmovie-header text-center pt-2 text-uppercase"> </div>
                        <ul class="list-group list-group-light rightmovie">

                                    <li class="movielist d-flex align-items-center">
                                        <div class="right-movie-wrapper">
                                            

                                            <a href="/Movie/Crime/KillersoftheFlowerMoon/466420/movie">
                                                <img src="https://image.tmdb.org/t/p/w500/dB6Krk806zeqd0YNp2ngQ9zXteH.jpg" alt="HTML tutorial" class="rightmovieimg" />
                                            </a>
                                        </div>
                                        <div class="w-100">
                                            <div class="fw-bolder movierating text-warning text-left m-2">7.6</div>
                                            <div class="movie-title-section text-muted text-left m-2">Killers of the Flower Moon</div>
                                        </div>
                                    </li>
                                    <li class="movielist d-flex align-items-center">
                                        <div class="right-movie-wrapper">
                                            

                                            <a href="/Movie/Action/Freelance/897087/movie">
                                                <img src="https://image.tmdb.org/t/p/w500/7Bd4EUOqQDKZXA6Od5gkfzRNb0.jpg" alt="HTML tutorial" class="rightmovieimg" />
                                            </a>
                                        </div>
                                        <div class="w-100">
                                            <div class="fw-bolder movierating text-warning text-left m-2">6.4</div>
                                            <div class="movie-title-section text-muted text-left m-2">Freelance</div>
                                        </div>
                                    </li>
                                    <li class="movielist d-flex align-items-center">
                                        <div class="right-movie-wrapper">
                                            

                                            <a href="/Movie/Action/AManofReason/656156/movie">
                                                <img src="https://image.tmdb.org/t/p/w500/ePwZs1oOh4pg8UZP8DuVZZeIn89.jpg" alt="HTML tutorial" class="rightmovieimg" />
                                            </a>
                                        </div>
                                        <div class="w-100">
                                            <div class="fw-bolder movierating text-warning text-left m-2">6.5</div>
                                            <div class="movie-title-section text-muted text-left m-2">A Man of Reason</div>
                                        </div>
                                    </li>
                                    <li class="movielist d-flex align-items-center">
                                        <div class="right-movie-wrapper">
                                            

                                            <a href="/Movie/Drama/LeavetheWorldBehind/726209/movie">
                                                <img src="https://image.tmdb.org/t/p/w500/5qhtTPWNqzM1eo9QIIf5cyIUeAA.jpg" alt="HTML tutorial" class="rightmovieimg" />
                                            </a>
                                        </div>
                                        <div class="w-100">
                                            <div class="fw-bolder movierating text-warning text-left m-2">6.7</div>
                                            <div class="movie-title-section text-muted text-left m-2">Leave the World Behind</div>
                                        </div>
                                    </li>
                                    <li class="movielist d-flex align-items-center">
                                        <div class="right-movie-wrapper">
                                            

                                            <a href="/Movie/Comedy/Wonka/787699/movie">
                                                <img src="https://image.tmdb.org/t/p/w500/qhb1qOilapbapxWQn9jtRCMwXJF.jpg" alt="HTML tutorial" class="rightmovieimg" />
                                            </a>
                                        </div>
                                        <div class="w-100">
                                            <div class="fw-bolder movierating text-warning text-left m-2">7.3</div>
                                            <div class="movie-title-section text-muted text-left m-2">Wonka</div>
                                        </div>
                                    </li>
                        </ul>
                        
                    </div>

                    
  </div>


  <div class="row">

        <section class="col-8 movie-overview-container">
          {/* this is for add
          <div class="card"></div> */}

          <div class="card" style={{backgroundColor:'transparent'}}>

          <div class="d-flex justify-content-around ">

          

          {
            backEnd.downloadable === true ? <>
            
            
            {
            backEnd.download !== "" ?
            <>
            
            <a href={backEnd.download} target="_blank" class="mx-6" rel="noreferrer">
          <button alt="download" class="downloadButtonStyle">
              <i>d</i>
              <i>o</i>
              <i>w</i>
              <i>n</i>
              <i>l</i>
              <i>o</i>
              <i>a</i>
              <i>d</i>
              
            </button>
          </a> 
            
            </> : 

            <></>
          } 
            
          




          {
            backEnd.hindidownload !== "" ? <>

          <a href={backEnd.hindidownload} target="_blank" rel="noreferrer">
          <button alt="download Hindi Dub" class="downloadButtonStyle">
              <i>d</i>
              <i>o</i>
              <i>w</i>
              <i>n</i>
              <i>l</i>
              <i>o</i>
              <i>a</i>
              <i>d</i>
              
            </button>
          </a>
            </> : <></>
          }

            
            
            </> : 
            
            
            
            <></>
          }





          

           

          </div> 


          
          <div
      id="container-e53d6b1dfa2204cc62aba0669ef16a4f"
      ref={adContainerRef}
      style={{ width: '100%', height: 'auto' }} // Adjust styles as needed
    />


          <div>
            <h2 class="font-weight-bolder p-2 " style={{color:'#ffffff'}}>{movieProps?.title}</h2>
          </div>


          <div class="row pb-2 justify-content-center">

            <div class="col-2 movie-overview-img-container">

              <img 
              
              class='watchmovieimg text-center' src={`https://image.tmdb.org/t/p/original/${movieProps?.poster_path}`}
              
              alt={movieProps?.original_title ? movieProps?.original_title : "movie poster"}
              />

            </div>
            <div class="col-10 movie-overview-desc-container">

              <div class="genre-section">
                <div class="genrescolor d-inline-block m-1 p-1">Thriller</div>
                <div class="genrescolor d-inline-block m-1 p-1">Horror</div>
              </div>

              <div>
                    <span class="p-1">{movieProps?.release_date ? movieProps.release_date.split("-")[0] : "N/A"}
                    </span>
                    <span class="p-1">{movieProps?.vote_average}
                     </span>
                    
                    <span class="p-1 pl-1">
                    {movieProps?.vote_count}
                     </span>
              </div>


              <div class="watchmovieplot p-2">
                
             <p>{movieProps?.overview}</p> 
              </div>

            </div>

          </div>

          </div>
        </section>

  </div>




    


  
</div>



          <Footer />
    </ div>
  )
}



export default MovieScreen